import { getActivePurchases } from '../../services/getActivePurchases'
import { getInactivePurchases } from '../../services/getInactivePurchases'
import type { GetActivePurchase } from '../../types/activePurchases.types'
import type { GetInactivePurchase } from '../../types/inactivePurchases.types'
import type { GetPurchaseProps } from '../../types/purchases.types'
import { adaptActivePurchases } from '../adapters/adaptActivePurchases/adaptActivePurchases'
import { adaptInactivePurchases } from '../adapters/adaptInactivePurchases/adaptInactivePurchases'
import { PossibleInfo } from '../constants'

export const userPurchases: Record<
	PossibleInfo,
	{
		apiFetch: (
			arg0: GetPurchaseProps
		) => Promise<GetActivePurchase[] | GetInactivePurchase[]>
		adaptFunction: Function
	}
> = {
	[PossibleInfo.ACTIVE_PURCHASE]: {
		apiFetch: (GetPurchaseProps) => getActivePurchases(GetPurchaseProps),
		adaptFunction: (activePurchases: GetActivePurchase[]) =>
			adaptActivePurchases({ activePurchases }),
	},
	[PossibleInfo.INACTIVE_PURCHASE]: {
		apiFetch: (GetPurchaseProps) => getInactivePurchases(GetPurchaseProps),
		adaptFunction: (inactivePurchases: GetInactivePurchase[]) =>
			adaptInactivePurchases({ inactivePurchases }),
	},
}
